// ============================================================================
// DATA SYNC — Cross-instance refresh via custom DOM events
// ============================================================================
// When a mutation hook (create/update/delete) succeeds, it broadcasts a change
// event. All useXxx() fetch hooks listening for that event auto-refetch,
// keeping every mounted screen in sync without a full page refresh.

import { useEffect } from 'react';

/** Broadcast a data-change event so all listeners for this key refetch */
export const notifyDataChanged = (key: string) => {
  window.dispatchEvent(new Event(`data-changed:${key}`));
};

/** Hook: auto-refetch when a data-change event fires for this key */
export const useDataChangeListener = (key: string, refetchFn: () => void) => {
  useEffect(() => {
    const handler = () => { refetchFn(); };
    window.addEventListener(`data-changed:${key}`, handler);
    return () => window.removeEventListener(`data-changed:${key}`, handler);
  }, [key, refetchFn]);
};
